<div id="groupsTable">
  <div class="table-container">
    <mat-toolbar id="searchBar">
      <div class="searchInput">
        <mat-form-field class="full-width">
          <mat-label>Recherche</mat-label>
          <input matInput [(ngModel)]="selectedFilter" (keyup)="filterChanged()">
        </mat-form-field>
      </div>
      @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DATABASE, ModuleTypeEnum.DATABASE_GROUP, SubModuleTypeEnum.DATABASE_GROUP_INFO_HARDWARE)) {
        <div class="extraInput">
          <section>
            @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DATABASE, ModuleTypeEnum.DATABASE_GROUP, SubModuleTypeEnum.DATABASE_GROUP_INFO_NEW_GROUP)) {
              <button
                id="createDbBtn" mat-flat-button color="primary" (click)="openCreateGroupDialog()">Créer un groupe
              </button>
            }
          </section>
        </div>
      }
    </mat-toolbar>
    <table mat-table matSort [dataSource]="groupInfosDataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
        <td mat-cell *matCellDef="let element">{{element.name}}</td>
      </ng-container>
      <ng-container matColumnDef="groupId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id du groupe</th>
        <td mat-cell *matCellDef="let element">{{element.groupId}}</td>
      </ng-container>
      <ng-container matColumnDef="override">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="override-tags">
            <ms-license-override-tag [overrideType]="licenseService.getGroupOverrideType(element.groupId)"></ms-license-override-tag>
            @if (recentActivityService.isActiveGroup(element.groupId)) {
              <ms-recent-activity-tag></ms-recent-activity-tag>
            }
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="servers">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Serveur</th>
        <td mat-cell *matCellDef="let element">{{element.servers}}</td>
      </ng-container>
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Utilise le desktop</th>
        <td mat-cell *matCellDef="let element">
          @if (element.isActive) {
            <div class="b">
              <mat-icon>check_box</mat-icon>
            </div>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="authorizedVersion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Version(s) activée(s)</th>
        <td mat-cell *matCellDef="let element">
          @for (el of element?.releaseVersion; track el.id) {
            @if (el?.authorization !== UpdateTypeEnum.NOT_ALLOWED) {
              {{ el?.version }}:
              @if (el?.authorization === UpdateTypeEnum.ALLOWED) {
                <span>Activée</span>
              } @else if (el?.authorization === UpdateTypeEnum.PARTIALLY_ALLOWED) {
                <span>Partiellement activée</span>
              }
            }
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="btn-flex-container">
            <button mat-icon-button title="Informations du groupe" [routerLink]="['group-infos', element.groupId]">
              <mat-icon>info</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openVersionSelector(element, releaseActionEnum.ADD)">
                <mat-icon>add_circle</mat-icon>
                <span>Activer le groupe</span>
              </button>
              <button mat-menu-item (click)="openVersionSelector(element, releaseActionEnum.REMOVE)">
                <mat-icon>remove_circle</mat-icon>
                <span>Désactiver le groupe</span>
              </button>
              @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.LICENSES, undefined, undefined) && canShowGroupOverrideActions(element.groupId)) {
                <button mat-menu-item (click)="openGroupOverrideDialog(element)">
                  <mat-icon>block</mat-icon>
                  <span>Bloquer le groupe</span>
                </button>
                @if (canUnblockGroup(element.groupId)) {
                  <button mat-menu-item (click)="unblockGroup(element)">
                    <mat-icon>lock_open</mat-icon>
                    <span>Débloquer le groupe</span>
                  </button>
                }
              }
            </mat-menu>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
  <ms-activity-indicator-with-messages [fullWidth]="true" [isLoading]="isLoading" [overlay]="true" [messages]="messages"></ms-activity-indicator-with-messages>
  <ms-activity-indicator-warmup [fullWidth]="true" [isLoading]="isWarmUp" [overlay]="true" [messages]="warmUpMessages" [groupId]="selectedGroupId"></ms-activity-indicator-warmup>
</div>
